<template>
	<div class="flashes">
		<flash
			v-for="(alert, index) in alerts"
			v-bind:key="index"
			:level="alert.level"
			:message="alert.message"
			@close="$delete(alerts, index)">
		</flash>
	</div>
</template>

<script>
	export default {
		props: [
			'alerts',
		]
	}
</script>
